import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { get, truncate, toNumber } from 'lodash-es';
//import { seperateNumbersWithCommas } from '../../utils/misc';
import 'antd/lib/descriptions/style/index.css';
import { localDate, humanizeDurationnHoursMinutes } from '../../utils/misc';
import JpLongLogo from '../../assets/companyLogo/jplogo.png';

import { Image } from 'antd';
import 'antd/lib/image/style/index.css';

const useStyles = createUseStyles({
  modal: {
    '& .modal-content': {
      width: '550px',
    },
    '& .modal-title': {
      fontSize: '17px',
    },
  },
  dataRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dataRowTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'top',
  },
  rowKey: {
    fontWeight: 400,
    marginBottom: '0px',
    color: '#8898aa',
    fontSize: '15px',
  },
  rowValue: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#4f4f4f',
    marginBottom: '0px',
    overflow: 'hidden',
    textOverflow: 'clip',
    textAlign: 'right',
  },
  brandLogo: {
    width: '85px !important',
    height: '18px !important',
    textAlign: 'center',
  },
});

export default function CustomerChargingSessionModal({
  toggleModalOpen,
  modalOpen,
  selectedSession,
}) {
  const classes = useStyles();

  function displayShortenedId(id) {
    if (id?.length > 20) {
      return truncate(id, {
        length: 40,
        seperator: '',
      });
    }
    return id;
  }
  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModalOpen}
      className={classes.modal}
    >
      <ModalHeader toggle={toggleModalOpen} style={{ textAlign: 'center' }}>
        Charging Session #
        {get(selectedSession, 'NOTE.TRANSACTION.TRANSACTIONID')}
      </ModalHeader>
      <ModalBody style={{ paddingTop: '0px' }}>
        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Transaction Id</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'NOTE.TRANSACTION.TRANSACTIONID')}
          </p>
        </div>
        <hr style={{ marginTop: '5px', marginBottom: '5px' }} />
        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Customer Name</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'NOTE.USER.NAME')}
          </p>
        </div>
        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Email Id</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'NOTE.USER.EMAIL')}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Phone No.</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'NOTE.USER.PHONE_NUMBER')}
          </p>
        </div>

        <hr style={{ marginTop: '5px', marginBottom: '5px' }} />

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Charger</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'NOTE.CHARGER.NAME')}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Charger Id</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'NOTE.CHARGER.ID')}
          </p>
        </div>

        <div className={classes.dataRowTop}>
          <p className={classes.rowKey}>Address</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'NOTE.CHARGER.ADDRESS')}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Connector Id</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'NOTE.TRANSACTION.CONNECTORID')}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Units consumed (in kwh)</p>
          <p className={classes.rowValue}>
            {toNumber(get(selectedSession, 'NOTE.KWH.KWH_CONSUMED')).toFixed(2)}{' '}
            kWh
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Tariff</p>
          <p className={classes.rowValue}>
            ₹ {get(selectedSession, 'NOTE.AMOUNT.AVG_PRICE') / 100}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Charging started at</p>
          <p className={classes.rowValue}>
            {localDate(get(selectedSession, 'NOTE.TRANSACTION.START_TIME'))}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Charging ended at</p>
          <p className={classes.rowValue}>
            {localDate(get(selectedSession, 'NOTE.TRANSACTION.END_TIME'))}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Duration</p>
          <p className={classes.rowValue}>
            {
              humanizeDurationnHoursMinutes(
                get(selectedSession, 'NOTE.DURATION'),
              ).string
            }
          </p>
        </div>

        <hr style={{ marginTop: '5px', marginBottom: '5px' }} />

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Order Id</p>
          <p className={classes.rowValue}>
            {get(selectedSession, 'EXTRA.payload.payment.entity.order_id') ||
              displayShortenedId(get(selectedSession, 'ID'))}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Amount added in Wallet</p>
          <p className={classes.rowValue}>
            ₹{' '}
            {(
              toNumber(get(selectedSession, 'NOTE.AMOUNT.AMOUNT_ADDED')) / 100
            ).toFixed(2)}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Amount Refunded</p>
          <p className={classes.rowValue}>
            ₹{' '}
            {(
              toNumber(get(selectedSession, 'NOTE.AMOUNT.AMOUNT_REFUNDED')) /
              100
            ).toFixed(2)}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Amount Consumed Exclusive Tax</p>
          <p className={classes.rowValue}>
            ₹{' '}
            {(
              toNumber(get(selectedSession, 'NOTE.AMOUNT.AMOUNT_CONSUMED')) /
                100 -
              toNumber(get(selectedSession, 'NOTE.AMOUNT.AMOUNT_TAX')) / 100
            ).toFixed(2)}
          </p>
        </div>

        <div className={classes.dataRow}>
          <p className={classes.rowKey}>Tax on Amount Consumed(18.0% GST)</p>
          <p className={classes.rowValue}>
            ₹{' '}
            {(
              toNumber(get(selectedSession, 'NOTE.AMOUNT.AMOUNT_TAX')) / 100
            ).toFixed(2)}
          </p>
        </div>

        <hr style={{ marginTop: '5px', marginBottom: '5px' }} />

        <div className={classes.dataRow}>
          <p
            style={{
              fontWeight: 700,
              marginBottom: '0px',
              color: '#8898aa',
              fontSize: '15px',
            }}
          >
            Net Total
          </p>
          <p
            style={{
              fontSize: '19px',
              fontWeight: 800,
              color: '#4f4f4f',
              marginBottom: '0px',
            }}
          >
            ₹{' '}
            {toNumber(
              get(selectedSession, 'NOTE.AMOUNT.AMOUNT_CONSUMED') / 100,
            ).toFixed(2)}
          </p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Image
            src={JpLongLogo}
            alt="Joulepoint"
            preview={false}
            className={classes.brandLogo}
          />
        </div>
      </ModalBody>
    </Modal>
  );
}
